var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bubble-modal',{attrs:{"value":_vm.open},on:{"change":function($event){return _vm.$emit('change')}}},[_c('ScoreboardContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }